const vestContainer = document.querySelector('.pulsating-vest');

if (vestContainer) {
  // Toggle class if in viewport
  const vestObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-active', entry.intersectionRatio > 0);
      });
    },
    { treshold: 1 },
  );

  vestObserver.observe(vestContainer);
}
